/*
 * "You May Also Like" rail.
 *
 * The recommendations list is re-rendered from a fetch by the
 * <product-recommendations> element, so the arrows are bound by delegation on
 * the document rather than to the buttons themselves.
 */
(function () {
  const PAGE = '.pdp-recs__viewport';

  function listFor(el) {
    const viewport = el.closest(PAGE);
    return viewport ? viewport.querySelector('.product-recommendations__list') : null;
  }

  function syncArrows(viewport) {
    const list = viewport.querySelector('.product-recommendations__list');
    if (!list) return;
    const max = list.scrollWidth - list.clientWidth;
    const prev = viewport.querySelector('.pdp-recs__arrow--prev');
    const next = viewport.querySelector('.pdp-recs__arrow--next');
    const scrollable = max > 4;
    [prev, next].forEach((b) => b && b.classList.toggle('is-hidden', !scrollable));
    if (prev) prev.classList.toggle('is-disabled', list.scrollLeft <= 4);
    if (next) next.classList.toggle('is-disabled', list.scrollLeft >= max - 4);
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.pdp-recs__arrow');
    if (!button) return;
    const list = listFor(button);
    if (!list) return;
    const direction = button.classList.contains('pdp-recs__arrow--next') ? 1 : -1;
    list.scrollBy({ left: direction * list.clientWidth, behavior: 'smooth' });
  });

  document.addEventListener(
    'scroll',
    (event) => {
      const list = event.target;
      if (!list.classList || !list.classList.contains('product-recommendations__list')) return;
      const viewport = list.closest(PAGE);
      if (viewport) syncArrows(viewport);
    },
    true
  );

  const refresh = () => document.querySelectorAll(PAGE).forEach(syncArrows);

  window.addEventListener('resize', refresh);
  document.addEventListener('DOMContentLoaded', refresh);
  // The list arrives after a fetch; watch for it rather than guessing a delay.
  new MutationObserver(refresh).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
  refresh();
})();
